module.exports = "/static/media/payment_logo--visa.a7099801.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/payment_logo--visa.svg
// module id = 1725
// module chunks = 0